import React, { useEffect, useState } from 'react';
import { Table, Pagination, Button, Form, ButtonGroup } from 'react-bootstrap';
import { Filter, PencilFill, TrashFill } from 'react-bootstrap-icons';
import APIserver from '../../../../api/axiosConfig';
import EditarDevModal from './editarDevModal'; // Ajusta la ruta si es necesario
import Swal from 'sweetalert2'; // Importamos SweetAlert2
import { Link } from 'react-router-dom';

function TablaDevoluciones() {
  const [showFilters, setShowFilters] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [devoluciones, setDevoluciones] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false); // Estado para mostrar el modal
  const [devolucionSeleccionada, setDevolucionSeleccionada] = useState(null); // Estado para almacenar la devolución seleccionada

  useEffect(() => {
    fetchDevoluciones();
  }, [currentPage, rowsPerPage]);

  const fetchDevoluciones = async () => {
    try {
      const response = await APIserver.get(`/api/devoluciones?page=${currentPage}&limit=${rowsPerPage}`);
      setDevoluciones(response.data.devoluciones);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching devoluciones:', error);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const renderPaginationItems = () => {
    const items = [];
    const pageRangeDisplayed = 5;
    const halfRange = Math.floor(pageRangeDisplayed / 2);

    let startPage = Math.max(1, currentPage - halfRange);
    let endPage = Math.min(totalPages, currentPage + halfRange);

    if (startPage > 1) {
      items.push(<Pagination.First key="first" onClick={() => setCurrentPage(1)} />);
      items.push(<Pagination.Prev key="prev" onClick={() => setCurrentPage(currentPage - 1)} />);
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => setCurrentPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages) {
      items.push(<Pagination.Next key="next" onClick={() => setCurrentPage(currentPage + 1)} />);
      items.push(<Pagination.Last key="last" onClick={() => setCurrentPage(totalPages)} />);
    }

    return items;
  };

  // Manejo del clic en el botón de editar
  const handleEditClick = (devolucion) => {
    setDevolucionSeleccionada(devolucion); // Guardamos la devolución seleccionada
    setShowEditModal(true); // Mostramos el modal de edición
  };

  // Manejo del clic en el botón de eliminar
  const handleDeleteClick = async (idDevolucion) => {
    // Usamos SweetAlert2 para la confirmación
    const isConfirmed = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta devolución será eliminada permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (isConfirmed.isConfirmed) {
      try {
        await APIserver.delete(`/api/devoluciones/${idDevolucion}`);
        Swal.fire('Eliminado!', 'La devolución ha sido eliminada.', 'success');
        fetchDevoluciones(); // Actualizamos la tabla después de eliminar
      } catch (error) {
        console.error('Error eliminando devolución:', error);
        Swal.fire('Error', 'Hubo un error al intentar eliminar la devolución', 'error');
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
};

  return (
    <div style={{ boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)' }}>
      <Table responsive className='text-center align-middle border'>
        <thead>
          <tr>
            <th colSpan={8}>
              <div className='d-flex justify-content-between align-items-center'>
                <div className='d-flex flex-wrap'>
                </div>
                <div>
                  <Form.Select className='ms-2' value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                    <option value='5'>5</option>
                    <option value='10'>10</option>
                    <option value='20'>20</option>
                    <option value='50'>50</option>
                  </Form.Select>
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <th>Devolución</th>
            <th>Factura</th>
            <th>Cliente</th>
            <th>Detalle</th>
            <th>Fecha</th>
            <th>Banco</th>
            <th>Monto</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {devoluciones.map((devolucion) => (
            <tr key={devolucion.idDevolucion}>
              <td>{devolucion.idDevolucion}</td>
              <td>
                <Link to={`/admin/Facturas/DetallesFactura/${devolucion.idFacV}/`} className='text-decoration-none'>
                  {devolucion.numFacv}
                </Link>
              </td>
              <td>
                <Link to={`/admin/Clientes/DetallesClientes/${devolucion.idCliente}/`} className='text-decoration-none'>
                  {devolucion.nomCliente}
                </Link>
              </td>
              <td>{devolucion.detalle}</td>
              <td>{formatDate(devolucion.fecha)}</td> {/* Formato de la fecha */}
              <td>
                <Link to={`/admin/Bancos/DetallesBancos/${devolucion.idBanco}/`} className='text-decoration-none'>
                  {devolucion.nomBanco}
                </Link>
              </td>
              <td>{devolucion.monto.toLocaleString()}</td>
              <td>
                <ButtonGroup>
                  <Button
                    variant='link'
                    className='text-warning'
                    title='Editar Devolución'
                    onClick={() => handleEditClick(devolucion)}
                  >
                    <PencilFill size={18} />
                  </Button>
                  <Button
                    variant='link'
                    className='text-danger'
                    title='Eliminar Devolución'
                    onClick={() => handleDeleteClick(devolucion.idDevolucion)}
                  >
                    <TrashFill size={18} />
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={8}>
              <div className='d-flex justify-content-center align-items-center'>
                <Pagination>{renderPaginationItems()}</Pagination>
              </div>
            </td>
          </tr>
        </tfoot>
      </Table>

      {/* Modal de Edición */}
      {devolucionSeleccionada && (
        <EditarDevModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          devolucion={devolucionSeleccionada}
        />
      )}
    </div>
  );
}

export default TablaDevoluciones;
